export const eventSeriesAttributes = `
  id
  name
  hostType
  user {
    id
    displayName
    username
    summary
    avatar {
      small {
        url
      }
      med {
        url
      }
    }
  }
  group {
    id
    name
    slug
    summary
    image {
      filename
    }
    verified
    public
  }
`;
